import { openDB } from 'idb';

const DB_NAME = 'AssessmentsDB';
const STORE_NAME = 'audioFiles';

const initDB = async () => {
    return openDB(DB_NAME, 1, {
        upgrade(db) {
            if (!db.objectStoreNames.contains(STORE_NAME)) {
                db.createObjectStore(STORE_NAME);
            }
        },
    });
};

const checkAudioExistsInDB = async (key) => {
    const db = await initDB()
    // סופר כמה רשומות קיימות עם המפתח הזה (תמיד יהיה 0 או 1)
    const count = await db.count(STORE_NAME, key)
    return count > 0
};

const saveAudioToDB = async (key, blob) => {
    const db = await initDB()
    return db.put(STORE_NAME, blob, key)
}

const getAudioFromDB = async (key) => {
    const db = await initDB()
    return db.get(STORE_NAME, key)
}

const deleteAudioFromDB = async (key) => {
    const db = await initDB()
    return db.delete(STORE_NAME, key)
}

/**
 * שולפת את כל המפתחות והערכים (ההקלטות) מ-IndexedDB
 * @returns {Promise<Array<{key: string, blob: Blob}>>}
 */
const getAudioForUserFromDB = async (userId) => {
    try {
        const db = await initDB();
        const tx = db.transaction(STORE_NAME, 'readonly');
        const store = tx.objectStore(STORE_NAME);

        const keys = await store.getAllKeys();
        const values = await store.getAll();
        await tx.done;

        const results = [];

        // עוברים על כל המפתחות ומסננים רק את אלו שמתחילים ב-user_ID של המשתמש הנוכחי
        const userPrefix = `user_${userId}_`;

        keys.forEach((key, index) => {
            // אם המפתח מתחיל בקידומת של המשתמש הנוכחי, נוסיף למערך
            if (typeof key === 'string' && key.startsWith(userPrefix)) {
                results.push({
                    key: key, // עדיין יכיל משהו כמו 'user_123_assessment_audio_456'
                    blob: values[index]
                });
            }
        });

        return results;

    } catch (error) {
        console.error("שגיאה בשליפת קבצים מ-IndexedDB:", error);
        return [];
    }
};

export { getAudioForUserFromDB, initDB, checkAudioExistsInDB, saveAudioToDB, getAudioFromDB, deleteAudioFromDB }